import client from './inventory-request';

// Tax Master — HSN code -> GST rate lookup (flat master, no hierarchy).
// API: GET /inventory/tax-masters/
export const getTaxMasters = (p) => client.get('/inventory/tax-masters/', p);
// API: GET /inventory/tax-masters/{id}/
export const getTaxMaster = (id) => client.get(`/inventory/tax-masters/${id}/`);
// API: GET /inventory/tax-masters/by-hsn/{hsn_code}/
export const getTaxMasterByHsn = (hsnCode) => client.get(`/inventory/tax-masters/by-hsn/${hsnCode}/`);
// API: POST /inventory/tax-masters/
export const createTaxMaster = (body) => client.post('/inventory/tax-masters/', body);
// API: PATCH /inventory/tax-masters/{id}/
export const updateTaxMaster = (id, body) => client.patch(`/inventory/tax-masters/${id}/`, body);
// API: DELETE /inventory/tax-masters/{id}/ — soft deactivate (is_active=false)
export const deleteTaxMaster = (id) => client.delete(`/inventory/tax-masters/${id}/`);
